import http, { url } from '../../http'

const API_URL = "items_companies"

class items2API {

  async getI() {
    const response = await http(`${API_URL}` , 'POST' )
    return response
  } 

}

export default new items2API()